// extracted by mini-css-extract-plugin
export default {"searchInput":"styles_searchInput__lFUhl","input":"styles_input__skIPr","searchIcon":"styles_searchIcon__0HUvJ"};